<template>
  <section class="d-flex justify-center align-center fill-height">
    <img
      v-if="settings.media.type === 'image'"
      style="max-width: 100%; max-height: 400px; object-fit: contain"
      :height="settings.media.height"
      :src="settings.media.content"
    />              
    <iframe
      v-if="settings.media.type === 'youtube'"
      style="border: none"
      :height="$vuetify.breakpoint.mdAndUp ? '316px' : '100%'"
      :width="$vuetify.breakpoint.mdAndUp ? '534px' : '100%'"
      :src="formatYoutube(settings.media.videoid)"
    ></iframe>    
  </section>  
</template>

<script>
export default {
  name: 'AboutMedia',
  props: {
    settings: {type: Object, required: true}
  },

  methods: {
    formatYoutube(code) {
      return `https://www.youtube.com/embed/${code}`;
    }    
  }
}
</script>